import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

import SoftBox from "../../../../components/SoftBox";
import SoftTypography from "../../../../components/SoftTypography";
import SoftButton from "../../../../components/SoftButton";
import { ADD_WIDGETS_TO_LIST } from "../../../../api/userWidgets";
import { refetchUserData } from "../../../../redux/auth/actions";
import { UseUserId } from "../../../../hooks/auth";

const TopKPI = ({ widget, closeModal, setButtonLabel, setReFetch }) => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const userId = UseUserId();

  const triggerSave = async () => {
    setLoading(true);
    const payload = {
      userId,
      key: widget.key,
      category: widget.category,
      title: widget.title,
    };

    try {
      await ADD_WIDGETS_TO_LIST(payload);
      dispatch(refetchUserData(userId));
      setTimeout(() => {
        setButtonLabel("Deactivate");
        toast.success("Widget activated successfully");
        setReFetch();
        closeModal();
      }, 1000);
    } catch (error) {
      console.log(error.response);
    }
    setLoading(false);
  };

  return (
    <>
      <SoftBox
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "420px",
          margin: "0 auto",
          textAlign: "center",
          gap: "16px",
        }}
      >
        <SoftTypography variant="p" sx={{ color: "#67748E" }}>
          Are you ready to activate your widget and unlock its full potential?
        </SoftTypography>
        <SoftTypography variant="h2" sx={{ color: "#0F172A" }}>
          Top KPI Widget
        </SoftTypography>
      </SoftBox>
      <SoftBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap="1rem"
        sx={{ marginTop: "2rem" }}
      >
        <SoftButton
          onClick={closeModal}
          disabled={loading}
          loading={loading}
          sx={{
            width: "100%",
            textTransform: "none",
            borderRadius: "4px",
            // light glass secondary button
            border: "1px solid rgba(15,23,42,0.12)",
            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
            background: "rgba(15,23,42,0.03)",
            color: "#475467",
            "&:hover": {
              background: "rgba(15,23,42,0.06)",
            },
          }}
        >
          Cancel
        </SoftButton>

        <SoftButton
          color="primary"
          type="submit"
          sx={{
            width: "100%",
            textTransform: "none",
          }}
          onClick={triggerSave}
          disabled={loading}
          loading={loading}
        >
          Activate
        </SoftButton>
      </SoftBox>
    </>
  );
};

export default TopKPI;
